import React from 'react';
import { useIntl } from 'react-intl';
import { Virtuoso } from 'react-virtuoso';
import { Bundle } from 'src/models/bundle';
import { DqText } from '../../../components/dq-text';
import { BundleMessages } from '../../../intl/BundleMessages';
import { BundlesListInfiniteItem } from './BundlesListInfiniteItem';

interface BundlesListInfiniteProps {
  /** The list of bundles to display. */
  bundles: Bundle[];
  /** The total number of bundles in the list, including any bundles not yet fetched. */
  totalCount: number;
  /** Indicates if the entire result set was loaded */
  loadedEntireResults: boolean;
}

const renderItem = (index: number, bundle: Bundle) => {
  return <BundlesListInfiniteItem bundle={bundle} />;
};

const keyAccessor = (index: number, bundle: Bundle) => bundle._id;

/** A presentation component which renders the list of bundles using an infinite scroll strategy. */
export const BundlesListInfinite: React.FC<BundlesListInfiniteProps> = props => {
  const { formatMessage } = useIntl();

  return (
    <Virtuoso<Bundle>
      data={props.bundles}
      totalCount={props.totalCount}
      itemContent={renderItem}
      computeItemKey={keyAccessor}
      components={{
        Footer: () => {
          return (
            <div className="ion-text-center ion-padding-top">
              <DqText variant={'h3'}>
                {props.loadedEntireResults
                  ? formatMessage(BundleMessages.endOfResultsMessage)
                  : formatMessage(BundleMessages.endOfBundlesListMessage)}
              </DqText>
            </div>
          );
        },
      }}
    />
  );
};
